<template>
  <section v-if="product.screenShots != null && product.screenShots.length > 0" class="px-sm-0 px-xxs-3">
    <h5>{{ $t('product.screenshots', {product: this.globalResources.productTranslation.Single}) }}</h5>
    <figure>
      <ProductScreenshotsList
        ref="productScreenshotsListComponent"
        :screenshot-urls="product.screenShots"
        @click="clicked"
      />
    </figure>
  </section>
</template>

<script>
import ProductScreenshotsList from '@/components/ProductScreenshotsList.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductScreenshots',
  components: {
    ProductScreenshotsList
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  },
  methods: {
    ...mapActions({
      showModal: 'modalManager/show'
    }),
    clicked (index) {
      this.showModal({ name: 'ProductScreenshotModal', configurations: { screenShots: this.product.screenShots, currentIndex: index } })
    }
  }
}
</script>
